export default "__VITE_ASSET__38b2f2af__"